import React from 'react'

const Sidebarprojecticon = () => {
    return (
        <div>
            <svg width="10" height="13" viewBox="0 0 10 13" fill="#A7AFB7" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.71398 7.03462L1.04614 12.8845C0.946112 12.952 0.829052 12.9915 0.707639 12.9988C0.586226 13.006 0.465085 12.9808 0.357335 12.9258C0.249584 12.8707 0.159331 12.788 0.0963449 12.6866C0.0333595 12.5851 4.19617e-05 12.4688 9.53674e-07 12.3502V0.65042C-8.01086e-05 0.531782 0.0331488 0.415385 0.0960855 0.313844C0.159022 0.212302 0.249268 0.12949 0.357039 0.074381C0.464812 0.019272 0.586 -0.00603138 0.707472 0.00121319C0.828943 0.00845776 0.946065 0.0479739 1.04614 0.115479L9.71398 5.96538C9.80228 6.02546 9.8744 6.10544 9.9242 6.19852C9.974 6.2916 10 6.39502 10 6.5C10 6.60498 9.974 6.7084 9.9242 6.80148C9.8744 6.89456 9.80228 6.97454 9.71398 7.03462Z" fill="#A7AFB7" />
            </svg>
        </div>
    )
}

export default Sidebarprojecticon
